<!--<div class="pagebrk"></div>
  <printheaderview>
  </printheaderview>-->
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card background-color-wt">
      <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px">

        <!--<div class="col-md-12 padding-left-0px">
          <div class="row margin-left-0px">
            <div class="col-md-1 padding-left-0px padding-right-0px">
              <img [src]="logo" class="user-image-circle-65px img7">
            </div>

            <div class="col-md-6">
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-familysubhead">{{HeaderLine1}}</label>
              </div>
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-family">{{HeaderLine2}}</label>
              </div>
              <div class="row margin-left-0px" *ngIf="GST">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">GST:</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{GST}}</label>
                </div>
              </div>
              <div class="row margin-left-0px" *ngIf="DL">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">CIN:</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DL}}</label>
                </div>
              </div>
            </div>

            <div class="col-md-5 padding-right-5px border-color-blue" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Customer Details</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-familysubhead float-right font-weight-bold font-color-blue">{{l.DisplayName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal font-color-blue">ID : {{l.FormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Sex/Age : {{l.Gender}}/{{l.Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal"><i class="fas fa-phone"></i> : {{l.Telephone1}}</label>
                </div>
              </div>

            </div>
          </div>
        </div>-->

      </div>
      <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

        <div class="row">
          <div class="col-print-12 text-align-center padding-top-5px">
            <label class="font-familyhead">Specimen Collection</label>
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px" *ngIf="LabPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient Name:</label>
                </div>
                <div class="col-print-8" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{l.DisplayName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="LabPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">ID:</label>
                </div>
                <div class="col-print-8" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{l.FormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="LabOrderResultsData">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Lab Order No:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{LabOrderResultsData.LabOrderCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="LabOrderResultsData">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Lab Order Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{LabOrderResultsData.RecievedOn | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px" *ngIf="LabPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Age / Gender:</label>
                </div>
                <div class="col-print-8" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Gender}}/{{l.Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="LabPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Telephone:</label>
                </div>
                <div class="col-print-8" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Telephone1}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Branch:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">{{Branchname}}</label>
                </div>
              </div>
              <!--<div class="row margin-left-0px margin-right-0px">
    <div class="col-print-4">
      <label class="margin-bottom-0px font-family font-weight-normal">Doctor:</label>
    </div>
    <div class="col-print-8">
      <label class="margin-bottom-0px font-family float-right font-weight-normal">{{BillData2.PrescriberName}}</label>
    </div>
  </div>-->
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row ">
            <div class="col-print-12 text-align-center padding-top-5px">
              <label class="font-familyhead">{{Specimen}}</label>
            </div>
          </div>
          
          <!--<div class="row " *ngIf="LabOrderResultsData">
            <div class="col-print-12 text-align-center padding-top-5px">
              <label class="font-familyhead">{{LabOrderResultsData.SpecimenCode}}</label>
            </div>
          </div>-->
        </div>
        <!--<div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px" *ngIf="LabOrderResultsData">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold">{{LabOrderResultsData.SpecimenCode}}</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>-->
        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-bold background-primary padding-top-2px padding-bottom-2px font-family text-align-left">
                          Code
                        </th>

                        <th class="font-weight-bold background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Date &amp; Time
                        </th>

                        <th class="font-weight-bold background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Tests
                        </th>
                        <th class="font-weight-bold background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Volume
                        </th>
                        <th class="font-weight-bold background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Method
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let m of GetSpecimen(Specimen)">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{m.SpecimenFormattedCode}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{m.RecievedOn| date:'MMM-dd-yyyy'}} &amp; {{m.RecievedOn| date: 'hh:mm a'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{m.TestsName}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{m.SpecimenCollectionAmount}}{{m.SpecimenCollectionUOM}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{m.CollectionMethod}}</td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
